/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Auto_Embed_On_UploadInputs */



/**
* | output |
* | --- |
* | "Auto-Embed on Upload" |
*
* @param {Spaces_Auto_Embed_On_UploadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_auto_embed_on_upload = /** @type {((inputs?: Spaces_Auto_Embed_On_UploadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Auto_Embed_On_UploadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auto-Einbetten beim Hochladen")
	return /** @type {LocalizedString} */ ("Auto-Embed on Upload")
});